import type { QuotaMeStatusDTO } from '@shared/schemas/quota';
import { formatQuotaDate } from './quota-format';
import { getEffectiveQuotaConstraint } from './quota-constraint';

export type QuotaBannerState = 'blocked' | 'hidden' | 'warning';

export function getQuotaBannerState(
  status: QuotaMeStatusDTO | undefined,
  dismissedRenewsAt: string | null,
): QuotaBannerState {
  if (!status) {
    return 'hidden';
  }

  const constraint = getEffectiveQuotaConstraint(status);
  if (constraint.blocked) {
    return 'blocked';
  }

  if (
    constraint.ratio !== null
    && constraint.ratio >= 0.8
    && constraint.resetAt !== dismissedRenewsAt
  ) {
    return 'warning';
  }

  return 'hidden';
}

export function getQuotaBlockedTooltip(status: QuotaMeStatusDTO | undefined) {
  if (!status) {
    return undefined;
  }

  const constraint = getEffectiveQuotaConstraint(status);
  if (!constraint.blocked) return undefined;

  const label = constraint.source === 'company' ? 'Quota entreprise atteint' : 'Quota atteint';
  return `${label}. Réinitialisation le ${formatQuotaDate(constraint.resetAt)}.`;
}
